import { Home , Anchor,  Airplay, BatteryCharging, Box, Truck, DollarSign, FolderPlus, Cpu, Command, Cloud, BarChart, Download, Users, ShoppingBag, Phone, List, Mail, MessageCircle, GitPullRequest, Monitor,Heart, Clock,Zap,CheckSquare, Calendar, Image,HelpCircle,Radio,Map,Edit, Sunrise,Package,Sliders,Layout,Server,Database,Search,File,Layers,UserCheck,Wifi, CreditCard,Settings, FileText} from "react-feather";

import { LuUser } from "react-icons/lu";
import { BsEvStation } from "react-icons/bs";
import { FaChargingStation } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";

import evtorlogo from "../../assets/images/evtorlogo.jpg"
import { code } from "../../api/DataApis";
// import evtorlogo from "../../../public/evtorlogo.png";

export const MENUITEMS = [
{
    menutitle: "General",
    menucontent:
      "Dashboards, Widgets, Enquire, Masters, Users, Stations, Chargers, Ocpp, RFID, Transactions",
    Items: [
      {
       path: `${process.env.PUBLIC_URL}/dashboard/default`,
        title: "Dashboard",
        icon: Home,
        type: "link",
      },
//masters
{

  title: "Masters",
  icon: Command,
  type: "sub",
  active: false,
  children: [
    {
      path: `/masters/categorylist`,
      title: "Categories",
      icon: Users,
      type: "link",
    },
    // {
    //   path: `/masters/deletedcategorylist`,
    //   title: "Deleted Categories",
    //   icon: Users,
    //   type: "link",
    // },


  ],

  
},

        //Admin
        {
          title: "Admins",
              icon: LuUser,
              type: "sub",
              active: false,
              children: [
                {
                  path: `/admin/list`,
                  title: "Admin Users",
                  icon: Users,
                  type: "link",
                },
             ],
      },
      {
        title: "User Management",
            icon: LuUser,
            type: "sub",
            active: false,
            children: [
              {
                path: `/usermanagement/users`,
                title: "Users",
                icon: Users,
                type: "link",
              },
           
         
              {
                path: `/usermanagement/users/deletedusers`,
                title: "Deleted Users",        
                icon: Users,
                type: "link",
              },
              {
                path: `/importExcel`,
                title: "Import Excel",
                icon: Users,
                type: "link",
              },
        ],
    },
    

      {
        title: "Products",
            icon: ShoppingBag,
            type: "sub",
            active: false,
            children: [
              {
                path: `/product-list`,
                title: "Products",
                icon: Users,
                type: "link",
              },
              {
                path: `/product/combo-list`,
                title: "Combo Products",
                icon: Users,
                type: "link",
              },
              ///
           ],
    },

  //Corporate
        {
          title: "Corporates",
              icon: LuUser,
              type: "sub",
              active: false,
              children: [
                {
                  path: `/corporate/list`,
                  title: "Corporates",
                  icon: Users,
                  type: "link",
                },
             ],
       },
    


{

  title: "Email Management",
  icon: Mail,
  type: "sub",
  active: false,
  children: [
    {
      path: `/email-processing-logs`,
      title: "Email Processing Logs",
      icon: Users,
      type: "link",
    },
    
    //permission-page



  ],

  
},
{

  title: "Orders",
  icon: Package,
  type: "sub",
  active: false,
  children: [
    {
      path: `/orders/all-orders-list`,
      title: "All Orders",
      icon: Package,
      type: "link",
    },
    // {
    //   path: `/orders/pending-orders-list`,
    //   title: "Pending Orders",
    //   icon: Users,
    //   type: "link",
    // },
    {
      path: `/orders/placed-orders-list`,
      title: "Placed Orders",
      icon: Users,
      type: "link",
    },
    {
      path: `/orders/shippment-orders-list`,
      title: "Shippment Orders",
      icon: Users,
      type: "link",
    },
    {
      path: `/orders/return-orders-list`,
      title: "Return Orders",
      icon: Users,
      type: "link",
    },
    {
      path: `/manualorder`,
      title: "Manual Orders",
      icon: Users,
      type: "link",
    },
    {
      path: `/manualorder/order-processing-logs`,
      title: "Order Processing Logs",
      icon: Users,
      type: "link",
    },
 ///
  
  ],

  
},
{

  title: "Shipment Management",
  icon: Truck,
  type: "sub",
  active: false,
  children: [
    {
      path: `/orders/shippment-logs`,
      title: "Shippment Logs",
      icon: Truck,
      type: "link",
    },
  



  ],

  
},
{

  title: "Device",
  icon: Cpu ,
  type: "sub",
  active: false,
  children: [
    {
      path: `/device`,
      title: "Devices",
      icon: Users,
      type: "link",
    },
    {
      path: `/device-tracking`,
      title: "Device Tracking",
      icon: Users,
      type: "link",
    },
    ///
    ], 
},
{

  title: "Companies",
  icon: Cpu ,
  type: "sub",
  active: false,
  children: [
    {
      path: `/company-list`,
      title: "Companies",
      icon: Users,
      type: "link",
    },
    {
      path: `/company-discount-list`,
      title: "Company Discount List",
      icon: Users,
      type: "link",
    }
    ///
    ], 
},

{

  title: "Settings",
  icon: Settings,
  type: "sub",
  active: false,
  children: [
    {
      path: `/permission-page`,
      title: "Permissions",
      icon: Users,
      type: "link",
    },
    
  



  ],

  
},


],
  },
];
